export const EDITOR__UPDATE_SCREENS = screens => ({
    type: 'EDITOR__UPDATE_SCREENS',
    payload: {
        screens,
    },
})

export const EDITOR__UPDATE_ACTIVE_SCREEN_ID = activeScreenId => ({
    type: 'EDITOR__UPDATE_ACTIVE_SCREEN_ID',
    payload: {
        activeScreenId,
    },
})

export const EDITOR__UPDATE_ACTIVE_POPUP_ID = activePopupId => ({
    type: 'EDITOR__UPDATE_ACTIVE_POPUP_ID',
    payload: {
        activePopupId,
    },
})

export const EDITOR__SHOW_POPUP = () => ({
    type: 'EDITOR__SHOW_POPUP',
    payload: {
        showPopup: true,
    },
})

export const EDITOR__HIDE_POPUP = () => ({
    type: 'EDITOR__HIDE_POPUP',
    payload: {
        showPopup: false,
    },
})

export const EDITOR__SET_PROJECT_TYPE_DATA = projectTypeData => ({
    type: 'EDITOR__SET_PROJECT_TYPE_DATA',
    payload: {
        projectTypeData,
    },
})

export const EDITOR__SET_PROJECT_TYPE = projectType => ({
    type: 'EDITOR__SET_PROJECT_TYPE',
    payload: {
        projectType,
    },
})

export const EDITOR__ENABLE_POPUPS = () => ({
    type: 'EDITOR__ENABLE_POPUPS',
    payload: {
        enablePopups: true,
    },
})

export const EDITOR__DISABLE_POPUPS = () => ({
    type: 'EDITOR__DISABLE_POPUPS',
    payload: {
        enablePopups: false,
    },
})

export const EDITOR__MOUNT = () => ({
    type: 'EDITOR__MOUNT',
    payload: {
        mounted: true,
    },
})

export const EDITOR__UNMOUNT = () => ({
    type: 'EDITOR__UNMOUNT',
    payload: {
        mounted: false,
    },
})
